"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
const orderPayment_1 = require("./orderPayment");
const lodash_keyby_1 = __importDefault(require("lodash.keyby"));
/**
 * Set status of order to COMPLETED
 * Can only be done when the order is in IN_PROGRESS status
 * @param event of type OrderPayment
 * @param prevState
 */
function default_1(event, prevState = {}) {
    var _a, _b, _c, _d;
    const order = prevState;
    // for some reason ORDER_PLACE is not being sent for order paid
    if (order.status === domain_1.OrderStatus.DRAFT &&
        event.paymentStatus === domain_1.OrderPaymentStatus.COMPLETE) {
        (0, utils_1.updateOrderAndItemsStatus)(order, domain_1.OrderStatus.CREATED, domain_1.OrderItemStatus.CREATED);
        order.createdAt = event.timestamp;
    }
    const existingPayment = (_a = order.payments) === null || _a === void 0 ? void 0 : _a.find(payment => payment.paymentRequestId === event.paymentRequestId);
    if (event.paymentTransactionRef && existingPayment)
        existingPayment.paymentTransactionRef = event.paymentTransactionRef;
    if (event.merchantCode && existingPayment)
        existingPayment.merchantCode = event.merchantCode;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    if ((existingPayment === null || existingPayment === void 0 ? void 0 : existingPayment.status) === domain_1.OrderPaymentStatus.COMPLETE) {
        return order;
    }
    const calculatedPaymentSurcharge = (0, utils_1.limitDecimalCount)((_b = order.payments.find(payment => payment.paymentRequestId === event.paymentRequestId &&
        payment.status === domain_1.OrderPaymentStatus.COMPLETE)) === null || _b === void 0 ? void 0 : _b.paymentSurcharge);
    if (existingPayment) {
        let paidAmount = existingPayment.amount;
        const onAccountPaidAmount = existingPayment.amount;
        if (event.paymentCompletedAt)
            existingPayment.paymentCompletedAt = event.paymentCompletedAt;
        if (event.paymentReceipt)
            existingPayment.paymentReceipt = event.paymentReceipt;
        if (event.cardType) {
            existingPayment.cardType = event.cardType;
        }
        if (event.paymentSurcharge && !calculatedPaymentSurcharge) {
            existingPayment.paymentSurcharge = (0, utils_1.limitDecimalCount)(event.paymentSurcharge);
            // Updating payment amount to include surcharge.
            existingPayment.amount = (0, utils_1.sumDecimals)([
                existingPayment.amount,
                event.paymentSurcharge,
            ]);
            existingPayment.tendered = (0, utils_1.sumDecimals)([
                existingPayment.tendered,
                event.paymentSurcharge,
            ]);
            paidAmount = existingPayment.amount;
        }
        if (event.paymentTip) {
            existingPayment.tip = event.paymentTip;
            // Updating payment amount to include surcharge.
            existingPayment.amount = (0, utils_1.sumDecimals)([
                existingPayment.amount,
                event.paymentTip,
            ]);
            existingPayment.tendered = (0, utils_1.sumDecimals)([
                existingPayment.tendered,
                event.paymentTip,
            ]);
            paidAmount = existingPayment.amount;
        }
        existingPayment.status = event.paymentStatus;
        const processingOrderItems = ((_c = existingPayment.paymentBreakdown) === null || _c === void 0 ? void 0 : _c.items) || [];
        // update paid status when paying for specific items
        if (processingOrderItems.length) {
            const processingOrderItemMaps = (0, lodash_keyby_1.default)(processingOrderItems, 'orderItemId');
            order.orderItems.forEach(item => {
                const paymentInfo = processingOrderItemMaps[item.id];
                // only update the items is doing payment fully
                if (paymentInfo && paymentInfo.quantityPaid == item.quantity) {
                    item.paymentStatus = event.paymentStatus;
                }
            });
        }
        if (event.paymentStatus === domain_1.OrderPaymentStatus.COMPLETE) {
            (0, orderPayment_1.processCompletedPayment)({
                order,
                deviceId: event.deviceId,
                paidAmount,
                roundOffDifference: existingPayment === null || existingPayment === void 0 ? void 0 : existingPayment.roundOffDifference,
                paymentTip: existingPayment.tip,
                paymentSurcharge: calculatedPaymentSurcharge
                    ? 0
                    : (_d = existingPayment.paymentSurcharge) !== null && _d !== void 0 ? _d : 0,
                isPrePayment: event.isPrePayment,
            });
            event.isOnAccountClearance &&
                (0, orderPayment_1.updateOnAccountPayment)(event.paymentStatus, onAccountPaidAmount, order, existingPayment.roundOffDifference);
        }
    }
    if (order.amountDue === 0 && order.status === domain_1.OrderStatus.ON_HOLD) {
        // for on hold orders when we pay completly the items should be shown as paid
        order.orderItems.forEach((item) => {
            item.paymentStatus = domain_1.OrderPaymentStatus.COMPLETE;
        });
    }
    const onAccountPayment = (0, utils_1.getOnAccountPayment)(order.payments);
    return {
        ...order,
        ...(onAccountPayment &&
            onAccountPayment.status !== domain_1.OrderPaymentStatus.COMPLETE &&
            !order.amountDue && { status: domain_1.OrderStatus.ON_ACCOUNT }),
    };
}
exports.default = default_1;
//# sourceMappingURL=paymentProcessed.js.map